import { render, staticRenderFns } from "./FormPasswordReset.vue?vue&type=template&id=a79ea3d6&"
import script from "./FormPasswordReset.vue?vue&type=script&lang=js&"
export * from "./FormPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a79ea3d6')) {
      api.createRecord('a79ea3d6', component.options)
    } else {
      api.reload('a79ea3d6', component.options)
    }
    module.hot.accept("./FormPasswordReset.vue?vue&type=template&id=a79ea3d6&", function () {
      api.rerender('a79ea3d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormPasswordReset.vue"
export default component.exports